import { KalturaRecordingType } from '@kaltura-ott/ott-client-types';
import { action } from 'mobx';
import { container, singleton } from 'tsyringe';

import type { RecordRepository } from '../stores';
import { DeleteRecordsTypesEnum, RecordArgs } from '../stores/recordRepository/record-repository-helper';

@singleton()
export class RecordRepositoryFacade {
  public get originalStore() {
    return container.resolve<RecordRepository>('recordRepository');
  }

  public get space() {
    return this.originalStore.space;
  }

  public get records() {
    return this.originalStore.records;
  }

  public get seriesRecords() {
    return this.originalStore.seriesRecords;
  }

  public get deleteRecordsOptions() {
    return this.originalStore.deleteRecordsOptions;
  }

  @action.bound
  public async getAvailableSpace() {
    return await this.originalStore.getAvailableSpace();
  }

  @action.bound
  public async definingDeleteOptions() {
    return await this.originalStore.definingDeleteOptions();
  }

  @action.bound
  async addRecord({ assetId, seriesId }: RecordArgs) {
    return await this.originalStore.addRecord({ assetId, seriesId });
  }

  @action.bound
  async removeRecord({ assetId, seriesId }: { assetId: number; seriesId?: string }, type: KalturaRecordingType) {
    return await this.originalStore.removeRecord({ assetId, seriesId }, type);
  }

  @action.bound
  async deleteRecords(type: DeleteRecordsTypesEnum) {
    return await this.originalStore.deleteRecords(type);
  }

  @action.bound
  getSingleRecord(assetId?: number) {
    return this.originalStore.getSingleRecord(assetId);
  }
  @action.bound
  getSeriesRecord(seriesId?: string) {
    return this.originalStore.getSeriesRecord(seriesId);
  }
}
